export const TITHI_NATURE_MAP = {
  1: 'Nanda',
  2: 'Bhadra',
  3: 'Jaya',
  4: 'Rikta',
  5: 'Purna',
  6: 'Nanda',
  7: 'Bhadra',
  8: 'Jaya',
  9: 'Rikta',
  10: 'Purna',
  11: 'Nanda',
  12: 'Bhadra',
  13: 'Jaya',
  14: 'Rikta',
  15: 'Purna',
  16: 'Nanda',
  17: 'Bhadra',
  18: 'Jaya',
  19: 'Rikta',
  20: 'Purna',
  21: 'Nanda',
  22: 'Bhadra',
  23: 'Jaya',
  24: 'Rikta',
  25: 'Purna',
  26: 'Nanda',
  27: 'Bhadra',
  28: 'Jaya',
  29: 'Rikta',
  30: 'Purna',
};

export function tithiNature(tithiNum) {
  if (typeof tithiNum !== 'number' || Number.isNaN(tithiNum)) return 'Neutral';
  return TITHI_NATURE_MAP[tithiNum] || 'Neutral';
}
